import { render, staticRenderFns } from "./CyberCustomerServiceLayout.vue?vue&type=template&id=aa7e0aca&scoped=true&"
import script from "./CyberCustomerServiceLayout.vue?vue&type=script&lang=js&"
export * from "./CyberCustomerServiceLayout.vue?vue&type=script&lang=js&"
import style0 from "./CyberCustomerServiceLayout.vue?vue&type=style&index=0&id=aa7e0aca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa7e0aca",
  null
  
)

export default component.exports